import dayjs from 'dayjs';


const addDayType = (itemDetails, dayTypesAll) => {
  // creating dayTypes must by definition be off-time thus no tours, dayOff field is populated
  const { date, dayTypeId, dayTypeComment, myDayTypeComment } = itemDetails;
  const tempDayTypeId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  const title = dayTypesAll
    .find((elem) => {
      return dayTypeId == elem.dayTypeId;
    }).dayTypeName;
    // address cloud server utc time offset (4 hours)
  let startTime = dayjs(date).startOf('day').subtract(4, 'hour').unix();
  let endTime = dayjs(date).endOf('day').subtract(4, 'hour').unix();

  // NOTE: Trying to Address defect 1954 but ==> NEW BUG!!


  const dayType = {
    rdtId: tempDayTypeId,
    title,
    rdtComment: dayTypeComment || " ",
    myDayComment: myDayTypeComment || " ",
    dayOff: {
      dorId: dayTypeId,  // not sure this is accurate
      title,
      startTime,
      endTime,
      comment: dayTypeComment || " "
    }
  };
  return dayType;
}

export default addDayType;
